var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "visibilityIcon",
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 0C2.25 0 0 6 0 6C0 6 2.25 12 8.25 12C14.25 12 16.5 6 16.5 6C16.5 6 14.25 0 8.25 0ZM8.25 1.5C12.207 1.5 14.2084 4.70032 14.8564 5.99707C14.2077 7.28482 12.1912 10.5 8.25 10.5C4.293 10.5 2.29155 7.29968 1.64355 6.00293C2.29305 4.71518 4.30875 1.5 8.25 1.5ZM8.25 3C6.59325 3 5.25 4.34325 5.25 6C5.25 7.65675 6.59325 9 8.25 9C9.90675 9 11.25 7.65675 11.25 6C11.25 4.34325 9.90675 3 8.25 3ZM8.25 4.5C9.07875 4.5 9.75 5.17125 9.75 6C9.75 6.82875 9.07875 7.5 8.25 7.5C7.42125 7.5 6.75 6.82875 6.75 6C6.75 5.17125 7.42125 4.5 8.25 4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOnIcon);
export default __webpack_public_path__ + "static/media/visibilityOnIcon.9aefe2c98cf8b69f838c4e8547c1bd5a.svg";
export { ForwardRef as ReactComponent };